<template>
    <v-container>
    <v-row class="text-center">
      <v-col col="12">
        <h1 class="font-weight-bold text-h4 mb--1 pa-12">
              EQUIPO
        </h1>
      </v-col>
    </v-row>
    <v-row class="text-center">
          <v-col col="12">
              <h3 class="transition-swing subtitle-2"> Somos Innuvex - Compañía de Soluciones Integrales</h3>
              <blockquote class="blockquote">
              <p>
                Experiencia y juventud, junto con amplios conocimientos en el sector tecnológico, se combinan
                a la perfeción para darte la respuesta más adecuada en cada necesidad que se le pueda plantear en el mundo
                tecnológico.
              </p>
              </blockquote>
          </v-col>
    </v-row>

    <v-row>
        <v-col sm="3" md="3" lg="3"
        v-for="(item,i) in team" :key="i">
          <v-card width="auto" elevation="5"  outlined tile>
                    <v-row align="center" class="mx-auto">
                      <v-img height="auto" :src="item.img"></v-img>
                      <v-card-title>{{item.name}}</v-card-title>
                      <v-card-text>{{item.description}}</v-card-text>
                      <v-card-actions>
                          <v-btn
                              color="deep-purple lighten-2"
                              text
                              :href="item.linkedin"
                              target="_blank"
                              >
                              linkedin
                          </v-btn>
                      </v-card-actions>
                    </v-row>
            </v-card>
        </v-col>

        <!-- <v-col sm="3" md="3" lg="3">
          <v-card  width="auto" elevation="5" outlined tile>
                  <v-row align="center" class="mx-auto">
                    <v-img height="auto" src="https://innuvex.com/static/media/team/carlos.PNG"></v-img>
                    <v-card-title>Carlos López</v-card-title>
                    <v-card-text>Lic. en Desarrollo de Software</v-card-text>
                    <v-card-actions>
                        <v-btn
                          color="deep-purple lighten-2"
                          text
                          href="https://www.linkedin.com/in/carlos-l%C3%B3pez-b3963a122/"
                          target="_blank"
                          >
                          linkedin
                        </v-btn>
                    </v-card-actions>
                  </v-row>
          </v-card>
        </v-col>

        <v-col sm="3" md="3" lg="3">
          <v-card width="auto" elevation="5" outlined tile>
                  <v-row align="center" class="mx-auto">
                    <v-img height="auto" src="https://innuvex.com/static/media/team/angel.PNG"></v-img>
                    <v-card-title>Ángel Otero</v-card-title>
                    <v-card-text>Lic. en Desarrollo de Software</v-card-text>
                    <v-card-actions>
                        <v-btn
                          color="deep-purple lighten-2"
                          text
                          href="https://www.linkedin.com/in/angel-otero-649292103/"
                          target="_blank"
                          >
                          linkedin
                        </v-btn>
                    </v-card-actions>
                  </v-row>
          </v-card>
        </v-col>

        <v-col sm="3" md="3" lg="3">
          <v-card width="auto"  elevation="5" outlined tile>
                  <v-row align="center" class="mx-auto">
                    <v-img height="auto" src="https://innuvex.com/static/media/team/Ashley.png"></v-img>
                    <v-card-title>Ashley De Hermoso</v-card-title>
                    <v-card-text>Ingeniera Aeroespacial</v-card-text>
                    <v-card-actions>
                        <v-btn
                          color="deep-purple lighten-2"
                          text
                          href="https://www.linkedin.com/in/ashley-de-hermoso-5a7794101/"
                          target="_blank"
                          >
                          linkedin
                        </v-btn>
                    </v-card-actions>
                  </v-row>
          </v-card>
        </v-col> -->

    </v-row>
    </v-container>

</template>

<script>
import axios from 'axios'
const BASE_URL = 'https://innuvex.com/'

export default {
  data () {
    return {
      team: [],
      dialog: false
    }
  },
  mounted () {
    this.getTeamMember()
  },
  methods: {
    getTeamMember () {
      var self = this
      // filtered = services.reduce((acc, item, index) => ((item.flyer) ? [...acc, index] : acc), []);
      axios({
        method: 'GET',
        url: BASE_URL + 'apiv1/team/'
      }).then((response) => {
        self.team = response.data.map((key) => {
          return {
            id: key.id,
            name: key.name,
            description: key.descripcion,
            linkedin: key.linkedin,
            img: key.image
          }
        })
      }).catch((e) => {
        console.error(e)
      })
    }
  }
}
</script>
